import * as React from "react";
function SvgIcon3(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32" {...props}><path d="M16.003 31.998l15.678-14.3a.99.99 0 00-.774-1.7h-9.055V2.219a2.336 2.336 0 00-2.437-2.221h-6.823a2.336 2.336 0 00-2.437 2.221v13.779H1.1a.99.99 0 00-.774 1.7z" fill="#7b7b7b" /></svg>;
}
export default SvgIcon3;